/**
 * @flow
 * @relayHash ff571ae102458e3bf2fe7e32e7889d99
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type LeaderboardResult_getWMSmallBusinessLeaderboard$ref = any;
export type fantasyFilterType = {|
  leaderboard_access?: ?string,
  name?: ?string,
  team_name?: ?string,
  guest_name?: ?string,
  option_name?: ?string,
  game1_id?: ?number,
  game2_id?: ?number,
  cumulative_leaderboard?: ?boolean,
  quarter_leaderboard?: ?number,
  event_id?: ?number,
|};
export type LeaderboardResultResultRefetchQueryVariables = {|
  filter?: ?fantasyFilterType
|};
export type LeaderboardResultResultRefetchQueryResponse = {|
  +$fragmentRefs: LeaderboardResult_getWMSmallBusinessLeaderboard$ref
|};
export type LeaderboardResultResultRefetchQuery = {|
  variables: LeaderboardResultResultRefetchQueryVariables,
  response: LeaderboardResultResultRefetchQueryResponse,
|};
*/


/*
query LeaderboardResultResultRefetchQuery(
  $filter: fantasyFilterType
) {
  ...LeaderboardResult_getWMSmallBusinessLeaderboard_Vt7Yj
}

fragment LeaderboardResult_getWMSmallBusinessLeaderboard_Vt7Yj on Query {
  getWMSmallBusinessLeaderboard(filter: $filter) {
    code
    message
    data {
      number_of_guests
      guests {
        _id
        guest_name
        fantasy_points
        score
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "filter",
    "type": "fantasyFilterType",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "filter",
    "variableName": "filter"
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "LeaderboardResultResultRefetchQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "FragmentSpread",
        "name": "LeaderboardResult_getWMSmallBusinessLeaderboard",
        "args": (v1/*: any*/)
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "LeaderboardResultResultRefetchQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "getWMSmallBusinessLeaderboard",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "smallBusinessDraftLeaderBoardType",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "code",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "message",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "data",
            "storageKey": null,
            "args": null,
            "concreteType": "smallBusinessDraftLeaderBoardDataType",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "number_of_guests",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "guests",
                "storageKey": null,
                "args": null,
                "concreteType": "front_events_guest",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "_id",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "guest_name",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "fantasy_points",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "score",
                    "args": null,
                    "storageKey": null
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "LeaderboardResultResultRefetchQuery",
    "id": null,
    "text": "query LeaderboardResultResultRefetchQuery(\n  $filter: fantasyFilterType\n) {\n  ...LeaderboardResult_getWMSmallBusinessLeaderboard_Vt7Yj\n}\n\nfragment LeaderboardResult_getWMSmallBusinessLeaderboard_Vt7Yj on Query {\n  getWMSmallBusinessLeaderboard(filter: $filter) {\n    code\n    message\n    data {\n      number_of_guests\n      guests {\n        _id\n        guest_name\n        fantasy_points\n        score\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '0e4b02f6d6739b885974c66f467abc8c';
module.exports = node;
